import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiBlockContent = class PiBlockContent extends Vue {
};
__decorate([
    Prop({ default: false })
], PiBlockContent.prototype, "isSearch", void 0);
__decorate([
    Prop({ default: "" })
], PiBlockContent.prototype, "size", void 0);
__decorate([
    Prop({ default: false })
], PiBlockContent.prototype, "borderBottom", void 0);
PiBlockContent = __decorate([
    Component
], PiBlockContent);
export default PiBlockContent;
